<template>
  <div class="home appmargin">
    <nav-bar v-if="!isweixin" title="首页" fixed style="margin-bottom: 50px;" />
    <Banner></Banner>

    <div class="match">
      <div @click="onSearch" class="searchbar">
        <img src="@/images/search@2x.png" />
        <div>搜索</div>
      </div>
      <MatchList :list="matchList" @infiniteHandler="infiniteHandler"></MatchList>
    </div>
    <infinite-loading @infinite="infiniteHandler"></infinite-loading>
  </div>
</template>

<script>
import { mapMutations } from "vuex";
import Banner from "@/components/banner/banner.vue";
import MatchList from "@/components/matchList";
import { getMatchList } from "@/libs/api";
import { isWeiXin } from "@/libs/utils";
import { NavBar } from "vant";
import { shareinfo } from "@/libs/wechat";
export default {
  name: "index",
  data() {
    return {
      page: 1,
      matchList: [],
      isweixin: true
    };
  },
  components: {
    Banner,
    MatchList,
    NavBar
  },
  methods: {
    infiniteHandler: function($state) {
      // this.handleSpinShow(true);
      getMatchList({ page: this.page }).then(res => {
        if (res.status == 200) {
          if (res.data.list.length > 0) {
            this.page += 1;
            this.matchList.push(...res.data.list);
            $state.loaded();
            if (res.data.list.length < 20) {
              $state.complete();
            }
          } else {
            $state.complete();
          }
        }
        // this.handleSpinShow(false);
      });
    },
    ...mapMutations(["handleSpinShow"]),
    getMatchList: function() {},
    onSearch() {
      this.$router.push({ name: "search" });
    }
  },
  mounted() {
    this.$nextTick(() => {
      shareinfo(window.location.href, "赛易云", "赛易云");
    });
  }
};
</script>

<style scoped lang="less">
.searchbar {
  background-color: #fff;
  height: 36px;
  width: 345px;
  border-radius: 4px;
  font-size: 12px;
  color: #aaaaaa;
  display: flex;
  align-items: center;
  margin: 0 auto;
  -moz-box-shadow: 0 2px 4px rgba(0, 0, 0, 0.12), 0 0 6px rgba(0, 0, 0, 0.04);
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.12), 0 0 6px rgba(0, 0, 0, 0.04);
  position: relative;
  box-sizing: border-box;
  margin-bottom: 10px;
  margin-top: 10px;
}

.searchbar img {
  width: 14px;
  height: 14px;
  padding-right: 15px;
  padding-left: 15px;
}
</style>

